import { googleTheme } from "./google";

export const DEFAULT_THEME = googleTheme